import { defineStore } from 'pinia'

import {
	clientStorageLocal,
	LOCAL_STORAGE_AUTH_ACCESS_TOKEN_KEY,
	LOCAL_STORAGE_AUTH_REFRESH_TOKEN_KEY,
	LOCAL_STORAGE_LAST_SELECTED_COMPANY_ID,
} from '@ao/utils'

const defaultUserState = {
	authAccessToken: null,
	authRefreshToken: null,
	isLoadingUser: false,
	currentUser: null,
	availableCompanies: [],
	isDefinedSelectedCompany: false,
	selectedCompanyId: null,
	userHaveAccessToCompany: true,
}

export const useUserStore = defineStore('user', {
	state: () => ({
		authAccessToken: defaultUserState.authAccessToken,
		authRefreshToken: defaultUserState.authRefreshToken,
		isLoadingUser: defaultUserState.isLoadingUser,

		currentUser: defaultUserState.currentUser,
		availableCompanies: defaultUserState.availableCompanies,

		/* загружен текущий пользователь и список доступных компаний */
		isLoadedUserData: false,
		isLoadingUserData: false,

		isDefinedSelectedCompany: defaultUserState.isDefinedSelectedCompany, // FIXME: не используется
		selectedCompanyId: defaultUserState.selectedCompanyId,
		userHaveAccessToCompany: defaultUserState.userHaveAccessToCompany,
	}),

	getters: {
		isAuth: (state) => {
			// debugger
			return !!state.authAccessToken && !!state.currentUser?.id && state.isLoadedUserData
		},
		isEmailConfirmed: (state) => state.currentUser && state.currentUser.email_confirm,
		getAuthToken: (state) => state.authAccessToken,
		isSuperuser: (state) => state.isAuth && !!state.currentUser?.is_superuser,
		isStaff: (state) => state.isAuth && !!state.currentUser?.is_staff,
		isSuperuserOrStaff: (state) => state.isSuperuser || state.isStaff,
		// currentUserData: (state) => state.currentUser, // TODO: удалить это, так-как не имеет смысла
	},

	actions: {
		setCurrentUser(user) {
			this.currentUser = user
		},

		setAvailableCompanies(values) {
			this.availableCompanies = values
		},

		setIsLoadedUserDataStatus(status) {
			return new Promise((resolve) => {
				this.isLoadedUserData = status
				resolve()
			})
		},

		setIsLoadingUserDataStatus(status) {
			return new Promise((resolve) => {
				this.isLoadingUserData = status
				resolve()
			})
		},

		setAuthToken({ access, refresh }) {
			return new Promise((resolve) => {
				this.authAccessToken = access
				this.authRefreshToken = refresh

				resolve()
			})
		},

		logout() {
			this.authAccessToken = null
			this.authRefreshToken = null
			this.currentUser = null

			clientStorageLocal.remove(LOCAL_STORAGE_AUTH_ACCESS_TOKEN_KEY)
			clientStorageLocal.remove(LOCAL_STORAGE_AUTH_REFRESH_TOKEN_KEY)
		},

		setSelectedCompanyId(companyId) {
			// console.log('user store - setSelectedCompanyId', companyId)
			return new Promise((resolve) => {
				this.selectedCompanyId = companyId
				clientStorageLocal.add(LOCAL_STORAGE_LAST_SELECTED_COMPANY_ID, companyId)
				resolve(companyId)
			})
		},

		setUserHaveAccessToCompanyStatus(status) {
			return new Promise((resolve) => {
				this.userHaveAccessToCompany = status
				resolve()
			})
		},

		resetUserStore() {
			this.authAccessToken = defaultUserState.authAccessToken
			this.authRefreshToken = defaultUserState.authRefreshToken
			this.isLoadingUser = defaultUserState.isLoadingUser
			this.currentUser = defaultUserState.currentUser
			this.availableCompanies = defaultUserState.availableCompanies
			this.isDefinedSelectedCompany = defaultUserState.isDefinedSelectedCompany
			this.selectedCompanyId = defaultUserState.selectedCompanyId
			this.userHaveAccessToCompany = defaultUserState.userHaveAccessToCompany
		},

	},
})
